<!-- <div class="text-center mt-4">
  <p class="p-0 m-0">Telefone: (48) 3626-6800</p>
  <p class="p-0 m-0">Rua Porto Alegre, 811 - Ed Centro Médico</p>
  <p class="p-0 m-0">Bairro Passagem - 88703-560 - Tubarão SC</p>
  <p class="p-0 m-0">www.Multmedcardio.com.br</p>
</div> -->

<div [innerHTML]="sanitizer.bypassSecurityTrustHtml(layoutImpressao?.rodape)">

</div>